import { ReactNode } from "react";

import { Stack, Typography } from "@mui/material";

interface Props {
  title: string;
  hideHeading?: boolean;
  children: ReactNode;
}

export function IncomeSectionCard({ title, hideHeading, children }: Props) {
  return (
    <Stack component="section" aria-label={title} sx={{ bgcolor: "background.paper", p: 2, gap: 2 }}>
      {!hideHeading && (
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
      )}
      {children}
    </Stack>
  );
}
